import { TokenHistoryLabel } from "kadow-jetpack-model";

export function isSupportedCTA(l: TokenHistoryLabel) {
    switch (l) {
        case TokenHistoryLabel.Google:
        case TokenHistoryLabel.Instagram:
        case TokenHistoryLabel.IGStory:
        case TokenHistoryLabel.Receipt:
        case TokenHistoryLabel.Facebook:
        case TokenHistoryLabel.TikTok:
        case TokenHistoryLabel.SnapChat:
        case TokenHistoryLabel.Share:
        case TokenHistoryLabel.Feedback:
        case TokenHistoryLabel.Custom:
        case TokenHistoryLabel.TripAdvisor:
        case TokenHistoryLabel.EmailOptIn:
        case TokenHistoryLabel.CheckIn:
        case TokenHistoryLabel.WhatsappGroup:
        case TokenHistoryLabel.Phone:
        case TokenHistoryLabel.PostalCode:
        case TokenHistoryLabel.Birthday:
        case TokenHistoryLabel.FirstName:
        case TokenHistoryLabel.NPS:
        case TokenHistoryLabel.CustomForm:
        case TokenHistoryLabel.DownloadApp:
            // Disabled because config is too complicated
            // case TokenHistoryLabel.BAO:
            return true;
        default:
            return false;
    }
}